import { useState } from "react";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";

function UploadPicture({ imagen }) {
  const [imageUrl, setImageUrl] = useState(null);
  const [imageName, setImageName] = useState(null);

  const handleFileUpload = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) {
      setImageName(null);
      setImageUrl(null);
      return;
    }

    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setImageUrl(reader.result);
      setImageName(file.name);
    };
    reader.readAsDataURL(file);
  };

  return (
    <Grid container sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
      <Grid item xs={12} sx={{ justifyContent: "center", display: "flex" }}>
        {imagen && !imageUrl && (
          <img
            src={imagen}
            alt="Uploaded Image"
            className="UploadPicturePreview"
          />
        )}
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Uploaded Image"
            className="UploadPicturePreview"
          />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sx={{
          justifyContent: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <label htmlFor="upload_image">
          <Button variant="contained" component="span">
            Subir imagen
          </Button>
          <input
            id="upload_image"
            hidden
            accept="image/*"
            type="file"
            onChange={handleFileUpload}
          />
        </label>
        {imageUrl && <label> {imageName} </label>}
      </Grid>
    </Grid>
  );
}

export { UploadPicture };
